<app-sidebar></app-sidebar>

<div class="content-container">
  <div class="container-fluid m-auto h-100">
    <!-- Main component for a primary marketing message or call to action -->
    <div class="row max-w-1320 minhv-100">
      <div class="col-sm-12">
        <h3 class="title mt-4">Data Plans</h3>
        <div class="row mt-4">
          <div class="col-sm-12 mt-4">
            <h5 class="title-2">
              One size doesn't fit all, That's why we have four customized plans
              for you
            </h5>
            <h3 class="fw-700 title-3 text-blue mt-4">
              start making the data work for you!!
            </h3>
          </div>
        </div>
      </div>
      <!-- m -->
      <div class="col-sm-12 my-20">
        <div class="col-xl-3 col-sm-6 col-md-8  col-lg-6 pull-left mr-bt-35">
          <div class="card card-layout">
            <div class="card-body">
              <div class="col-lg-12">
                <div class="row">
                  <label class="fw-700 text-sm py-2">Pre-Basic</label>
                </div>
                <div class="text-center">
                  <label class="fw-700"
                    >₹ <span class="fw-900 rupees py-2">499</span></label
                  >
                </div>
                <label class="py-2"
                  >Download and upload speed upto 20mbps with unlimited
                  data</label
                >
                <div class="row">
                  <div class="col-sm-12 py-2">
                    <div class="text-center">
                      <button type="button" class="btn btn-submit">
                        Recharge
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3  col-sm-6 col-md-8  col-lg-6 pull-left mr-bt-35">
          <div class="card card-layout">
            <div class="card-body">
              <div class="col-lg-12">
                <div class="row">
                  <label class="fw-700 text-sm py-2">Basic</label>
                </div>
                <div class="text-center">
                  <label class="fw-700"
                    >₹ <span class="fw-900 rupees py-2">599</span></label
                  >
                </div>
                <label class="py-2"
                  >Download and upload speed upto 50mbps with unlimited
                  data</label
                >
                <div class="row">
                  <div class="col-sm-12 py-2">
                    <div class="text-center">
                      <button type="button" class="btn btn-submit">
                        Recharge
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6 col-md-8  col-lg-6 pull-left mr-bt-35">
          <div class="card card-layout">
            <div class="card-body">
              <div class="col-lg-12">
                <div class="row">
                  <label class="fw-700 text-sm py-2">Pre-Basic</label>
                </div>
                <div class="text-center">
                  <label class="fw-700"
                    >₹ <span class="fw-900 rupees py-2">749</span></label
                  >
                </div>
                <label class="py-2"
                  >Download and upload speed upto 75mbps with unlimited
                  data</label
                >
                <div class="row">
                  <div class="col-sm-12 py-2">
                    <div class="text-center">
                      <button type="button" class="btn btn-submit">
                        Recharge
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6 col-md-8  col-lg-6 pull-left mr-bt-35">
          <div class="card card-layout">
            <div class="offer">offer</div>
            <div class="card-body">
              <div class="col-lg-12">
                <div class="row">
                  <label class="fw-700 text-sm py-2">Pre-Basic</label>
                </div>
                <div class="text-center">
                  <label class="fw-700"
                    >₹ <span class="fw-900 rupees py-2">949</span></label
                  >
                </div>
                <label class="py-2"
                  >Download and upload speed upto 100mbps with unlimited
                  data</label
                >
                <div class="row">
                  <div class="col-sm-12 py-2">
                    <div class="text-center">
                      <button type="button" class="btn btn-submit">
                        Recharge
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
